import { useCallback } from 'react';

import { Step } from 'react-joyride';

import { TourId } from './config';
import { useTourContext } from './TourProvider';

type UseTourOptions = {
  defaultTourId?: TourId;
};

export const useTour = (options?: UseTourOptions) => {
  const { currentTourId, run, steps, startTour, stopTour } = useTourContext();

  const start = useCallback(
    (tourId?: TourId, overrides?: { steps?: Step[] }) => {
      const idToUse = tourId ?? options?.defaultTourId;

      if (!idToUse) return;

      startTour(idToUse, overrides);
    },
    [options?.defaultTourId, startTour],
  );

  return {
    currentTourId,
    isRunning: run,
    steps,
    startTour: start,
    stopTour,
  };
};
